import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { ProductService } from 'src/app/services/product.service';
import { AuthService } from 'src/app/services/auth.service';
import { ErrorHandlerService } from 'src/app/services/error-handler.service';
import { MessageService } from 'primeng/api';
import { catchError } from 'rxjs/operators';
import { EMPTY } from 'rxjs';
import { Capacitor } from '@capacitor/core';

@Component({
  selector: 'app-ga4-auth',
  templateUrl: './ga4-auth.component.html',
  styleUrls: ['./ga4-auth.component.scss'],
  providers: [MessageService]
})
export class Ga4AuthComponent implements OnInit {
  loading = true;
  errorMessage = '';
  private ga4Data: any = null;
  private selectedStoreId = '';

  constructor(
    private route: ActivatedRoute,
    private errorHandler: ErrorHandlerService,
    private productService: ProductService,
    private authService: AuthService,
    private messageService: MessageService,
    private router: Router,
  ) {}

  private ensureStorageFromOpener(): Promise<void> {
    return new Promise((resolve) => {
      try {
        const ch = new BroadcastChannel('oauth-storage');
        const timeout = setTimeout(() => { ch.close(); resolve(); }, 800);
        ch.onmessage = (e) => {
          if (e.data?.type === 'storage-dump') {
            const p = e.data.payload || {};
            for (const k of Object.keys(p)) {
              if (p[k] != null) localStorage.setItem(k, String(p[k]));
            }
            clearTimeout(timeout);
            ch.close();
            resolve();
          }
        };
        ch.postMessage({ type: 'request-storage' });
      } catch { resolve(); }
    });
  }

  ngOnInit(): void {
    this.route.queryParams.subscribe(async params => {
      await this.ensureStorageFromOpener();

      const code = params['code'];
      const state = params['state'];
      const error = params['error'];

      if (state) {
        try {
          const stateObj = JSON.parse(atob(state));
          this.selectedStoreId = stateObj.selectedStoreId || '';
          if (this.selectedStoreId) localStorage.setItem('ss_SelectedStoreId', this.selectedStoreId);
          if (stateObj.accessToken) localStorage.setItem('access_token', stateObj.accessToken);
        } catch (e) {
          console.warn('State inválido', e);
        }
      }

      if (!this.selectedStoreId) {
        this.selectedStoreId = localStorage.getItem('ss_SelectedStoreId') || '';
      }

      if (error) {
        this.showError('Autorização negada pelo usuário.');
        return;
      }

      if (code && state) this.finishGa4Login(code, state);
    });
  }

  private finishGa4Login(code: string, state: string) {
    this.productService.ga4Oauth(code, state).pipe(
      catchError((error) => {
        if (
          error &&
          (error.message === 'GA4 API analytics.properties error (404)' ||
            error.error?.message === 'GA4 API analytics.properties error (404)')
        ) {
          this.showError('É necessário criar pelo menos 1 fluxo de dados no Google Analytics para finalizar a integração.');
        } else {
          this.showError('Não foi possível autenticar no GA4.');
        }
        return EMPTY;
      })
    ).subscribe(data => {
      this.ga4Data = data;
      this.autoIntegrate();
    });
  }

  private autoIntegrate() {
    if (!this.selectedStoreId || !this.ga4Data) {
      this.showError('Loja não identificada. Tente novamente.');
      return;
    }

    localStorage.setItem('ss_SelectedStoreId', this.selectedStoreId);

    const payload = {
      access_token: this.ga4Data.access_token,
      refresh_token: this.ga4Data.refresh_token,
      expires_in: this.ga4Data.expires_in,
      scope: this.ga4Data.scope,
      account_id: this.ga4Data.account_id,
      account_name: this.ga4Data.account_name,
      property_id: this.ga4Data.property_id,
      property_name: this.ga4Data.property_name,
      email: this.ga4Data.email,
      picture: this.ga4Data.picture,
      status: 'active',
      form_value: {
        name: this.ga4Data.account_name || this.ga4Data.email || 'GA4 User',
        email: this.ga4Data.email || null,
        picture: this.ga4Data.picture || null,
      },
    };

    this.productService.createAppsStore2('ga4', payload).pipe(
      catchError(() => {
        this.showError('Não foi possível salvar integração.');
        return EMPTY;
      })
    ).subscribe(() => {
      this.loading = false;
      // const isAndroid = /android/i.test(navigator.userAgent);
      // if (isAndroid) {
      //   window.location.href = 'myslick://auth/ga4?result=success';
      //   return;
      // }
      try {
        const channel = new BroadcastChannel('oauth-channel');
        channel.postMessage({ type: 'ga4-connected' });
        channel.close();
      } catch {}
      try { window.close(); } catch {}
    });
  }

  private showError(msg: string) {
    this.loading = false;
    this.errorMessage = msg;
    this.messageService.add({ severity: 'error', summary: 'Erro', detail: msg });
    setTimeout(() => { try { window.close(); } catch {} }, 3000);
  }
}
